export default __webpack_public_path__ + "static/media/DMFullColourUK.93884d94.svg";